import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { status } = useAuth();
  if (status === "loading") {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[color:var(--bone)]">
        <div className="text-sm text-neutral-500">Laden…</div>
      </div>
    );
  }
  if (status === "anon") return <Navigate to="/login" replace />;
  return children;
}
